/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import events3 from "assets/images/schedule.png";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Slider from "react-slick";
// Material Kit 2 React examples
import { Link } from "react-router-dom";

// import testImg from "assets/images/sample.png";
import DateCard from "examples/Cards/DateCard";
// Images
import { useQuery } from "@apollo/client";
import * as React from "react";
import { RECENT_EVENTS } from "graphql/query/events";
// Custom CSS
import "../../assets/css/custom.css";

const SingleSlider = styled("div")({
  marginRight: "10px",
});
const HeadingText = styled("div")({
  color: "#0A0A0A",
  backgroundColor: "transparent",
  padding: 1,
  textTransform: "uppercase",
  opacity: "0.8",
  fontWeight: "400",
  fontFamily: "inherit",
});
function Events() {
  const [offset] = React.useState(0);
  const [eventsDatas, setEventsDatas] = React.useState([]);
  const { loading, error, data } = useQuery(RECENT_EVENTS, {
    variables: {
      eventsFilter: {
        orderColumn: "date",
        status: true,
        limit: 100,
        offset,
        orderDirection: "desc",
      },
    },
  });
  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  React.useEffect(() => {
    if (loading === false) {
      if (error) {
        setEventsDatas([]);
      } else {
        setEventsDatas(data.recentEvents.events);
      }
    }
  }, [data, loading, error]);
  return (
    <MKBox component="section" py={12}>
      {eventsDatas.length > 0 ? (
        <Container id="testimonial">
          <Grid
            container
            item
            xs={12}
            lg={6}
            justifyContent="center"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography variant="h2" py={3}>
              <img src={events3} className="events-img4" alt="" />
              <HeadingText className="heading-bg" sx={{ fontWeight: "bold" }}>
                Recent Events
              </HeadingText>
              <img src={events3} className="events-img3" alt="" />
            </MKTypography>
          </Grid>
          {eventsDatas.length >= 4 ? (
            <Slider {...settings}>
              {eventsDatas.map((events) => (
                <SingleSlider key={events.id}>
                  <Link to={`/event-videos/${events.id}`}>
                    <DateCard
                      image={events.thumbnail_image}
                      name={events.event_name}
                      date={events.date}
                    />
                  </Link>
                </SingleSlider>
              ))}
            </Slider>
          ) : (
            <Grid container spacing={3}>
              {eventsDatas.map((events) => (
                <SingleSlider key={events.id}>
                  <Link to={`/event-videos/${events.id}`}>
                    <DateCard
                      image={events.thumbnail_image}
                      name={events.event_name}
                      date={events.date}
                    />
                  </Link>
                </SingleSlider>
              ))}
            </Grid>
          )}
        </Container>
      ) : null}
    </MKBox>
  );
}

export default Events;
